import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '@avenir-client-web/base-control';
import { MaxLengthModule } from '@avenir-client-web/max-length';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, FormsModule, MaxLengthModule, TextareaModule],
})
export class TextAreaComponent extends BaseControlComponent<string> {
  @Input() rows: number;

  @Input() autoResize = false;

  @Input() maxLength: number;

  @Input() autoTrim = true;

  onBlur(): void {
    if (this.autoTrim) {
      this.onValueChange(this.value?.trim());
    }
  }
}
